import { CloseIcon } from '../../../../assets/icons/Svg'
import { clearPackage, resetPackageState, setPackageDetails } from '../../../../features/package/packageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedId, clearTypeOfAdditionalModal, clearTypeOfShowModalType, selectCurrentModalType, setTypeOfShowModalType } from '../../../../features/modal/modalSlice';

interface PackageModalHeaderProps {
    typOfAction: 'newPackage' | 'updatePackage'
}

export default function PackageModalHeader({ typOfAction }: PackageModalHeaderProps) {

    const typeModal = useSelector(selectCurrentModalType);
    const dispatch = useDispatch()

    const handleCloseNewPackageModal = () => {
        // dispatch(clearPackage());
        // dispatch(clearTypeOfAdditionalModal());
        // if (typeModal === 'newPackage') {
        //     dispatch(setTypeOfShowModalType('fbTypeModal'));
        //     dispatch(resetPackageState());
        // } else {
        //     dispatch(clearTypeOfShowModalType());
        // }
        // dispatch(clearSelectedId())

        dispatch(clearPackage());
        dispatch(clearTypeOfAdditionalModal());
        dispatch(resetPackageState());
        dispatch(clearTypeOfShowModalType());
        dispatch(clearSelectedId())
        dispatch(setPackageDetails({ packageType: null, typeOfAction: null }))
    }

    return (
        <>
            <div className="flex justify-between items-center py-1">
                <div className="items-start">
                    <p className="text-base items-start font-semibold leading-tight text-slate-900">
                        {typOfAction === 'newPackage' && 'New Package'}
                        {typOfAction === 'updatePackage' && 'Update Package'}
                    </p>
                </div>
                <div className="flex justify-end items-center">
                    <button
                        type="button"
                        className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                        onClick={handleCloseNewPackageModal}
                    >
                        <CloseIcon/>
                    </button>
                </div>
            </div>
            <hr className="h-px bg-gray-200 border-0" />
        </>
    )
}
